// extracted by mini-css-extract-plugin
export default {"mainButton":"styles_mainButton__rolyp"};